import { keepPreviousData, QueryFunctionContext, useQuery } from '@tanstack/react-query'
import { useDebounceValue } from 'usehooks-ts'

import { apiClient } from '../apiClient'

type Media = {
  id: string
  location: string
  filename: string
  mimeType: string
  thumbnailLgLocation?: string
  thumbnailSmLocation?: string
}

type MediaResponse = Media[]

const queryFn = async (ctx: QueryFunctionContext<readonly ['media', string[]]>) => {
  const mediaIds = ctx.queryKey[1]

  if (!mediaIds || mediaIds.length === 0) return

  const { data } = await apiClient.get<MediaResponse>(`/v2/media`, {
    params: {
      mediaIds: mediaIds.join(','),
    },
  })

  return data
}

export function useMediaByIds(mediaIds: string[]) {
  const [mediaIdsDebounced] = useDebounceValue(mediaIds, 1500)

  return useQuery({
    queryKey: ['media', mediaIdsDebounced] as const,
    queryFn: queryFn,
    placeholderData: keepPreviousData,
    enabled: mediaIds.length > 0,
  })
}
